import React from 'react';
import styled from "styled-components";
import { CampaignsUserJoinedCard } from "../../components";

const UserJoinedCampaigns = () => {
  return (
    <CampaignsUserJoinedMain className='campaigns-user-joined-main'>
      <CardContainer>
        <CampaignsUserJoinedCard />
      </CardContainer>
    </CampaignsUserJoinedMain>
  )
}

export default UserJoinedCampaigns

export const CampaignsUserJoinedMain = styled.main`
  background-color: #f8f8f8;
  padding: 80px 0;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 50px;
  max-width: 1200px;
  margin: 0 auto;
`;